import { useEffect, useRef } from "react";
import { useTranslation } from "@firecms/core";
import { sanitizeStoredFireCMSLocale } from "../i18n/adminLocales";

/** Ensures FireCMS UI locale is one of en/es/pt/fr on load and when storage changes. */
export function FirecmsLocaleBootstrap() {
  const { i18n } = useTranslation();
  const i18nRef = useRef(i18n);
  i18nRef.current = i18n;

  useEffect(() => {
    const apply = () => {
      const normalized = sanitizeStoredFireCMSLocale();
      const current = i18nRef.current.language.split("-")[0]?.toLowerCase() ?? "";
      if (current !== normalized) {
        void i18nRef.current.changeLanguage(normalized);
      }
    };

    apply();

    const onStorage = (event: StorageEvent) => {
      if (event.key === "firecms_locale") {
        apply();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return null;
}

/** Hide FireCMS built-in LanguageToggle (7 locales) when our selector is in the AppBar. */
export function HideFirecmsLanguageToggle() {
  useEffect(() => {
    const hide = () => {
      document.querySelectorAll("button").forEach((button) => {
        if (button.closest("[data-teamops-lang-toggle]")) {
          return;
        }
        const label = (
          button.getAttribute("aria-label") ??
          button.getAttribute("title") ??
          ""
        ).toLowerCase();
        if (
          label.includes("language") ||
          label.includes("idioma") ||
          label.includes("langue") ||
          label.includes("sprache")
        ) {
          button.style.display = "none";
        }
      });
    };

    hide();
    const observer = new MutationObserver(hide);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
